import { SORT_ORDER } from '../constants';

const useLocalSort = ({ content, sort }) => {
  const { direction, getSortValue } = sort;

  if (!sort || !getSortValue) {
    return [...content];
  }

  return [...content].sort((a, b) =>
    direction === SORT_ORDER.DESC ? getSortValue(b) - getSortValue(a) : getSortValue(a) - getSortValue(b),
  );
};

export default useLocalSort;
